import { api } from "@/http/api-client"
import type { TFinanceTransaction } from "@/http/finance/transaction-types"

export type TReportParams = {
  organizationSlug: string
  startDate: string
  endDate: string
  paidOnly?: boolean
}

export type TMonthlyOverviewItem = {
  month: number
  year: number
  income: number
  outcome: number
}

export type TCashFlowItem = {
  date: string
  balance: number
}

export type TCategoryAmount = {
  category: string
  total: number
}

export type TCategoryBreakdown = {
  income: TCategoryAmount[]
  expense: TCategoryAmount[]
}

export type TPersonAmount = {
  person: string
  total: number
}

export type TByPerson = {
  income: TPersonAmount[]
  expense: TPersonAmount[]
}

function buildSearchParams(params: TReportParams): string {
  const sp = new URLSearchParams()
  sp.set("organizationSlug", params.organizationSlug)
  sp.set("startDate", params.startDate)
  sp.set("endDate", params.endDate)
  if (params.paidOnly) sp.set("paidOnly", "true")
  return sp.toString()
}

export function getMonthlyOverview(params: TReportParams) {
  return api.get<{ data: TMonthlyOverviewItem[] }>(
    `/finances/reports/monthly-overview?${buildSearchParams(params)}`,
  )
}

export function getCashFlow(params: TReportParams) {
  return api.get<{ data: TCashFlowItem[] }>(
    `/finances/reports/cash-flow?${buildSearchParams(params)}`,
  )
}

export function getCategoryBreakdown(params: TReportParams) {
  return api.get<{ data: TCategoryBreakdown }>(
    `/finances/reports/category-breakdown?${buildSearchParams(params)}`,
  )
}

export function getByPerson(params: TReportParams) {
  return api.get<{ data: TByPerson }>(
    `/finances/reports/by-person?${buildSearchParams(params)}`,
  )
}

export function listReportTransactions(params: TReportParams) {
  return api.get<{ transactions: TFinanceTransaction[] }>(
    `/finances/reports/transactions?${buildSearchParams(params)}`,
  )
}
